import { Access } from "@p0security/shared/types/access/index";

export const SalesforceAiAccesses = {
  "permission-set": Access({
    label: "Permission set",
    description:
      "Grant an agent's API-only Salesforce user a permission set; only an agentic session can request it",
    maturity: "beta",
    delegation: {},
    parameters: {
      org: {
        type: "static",
        label: "Salesforce org",
        optional: true,
      },
      orgId: {
        type: "generated",
        label: "Salesforce org (resolved)",
      },
      permissionSet: {
        type: "static",
        label: "Permission set",
        description:
          "API name of a permission set on the P0 package's grantable list",
        multivalued: true,
      },
      /** Names the agent's Salesforce user: one per gateway session. The
       * gateway puts it in its token, and the token-exchange handler maps it
       * to the user. */
      agentKey: {
        type: "generated",
        label: "Agent key",
      },
    },
    generated: {
      // The gateway exchanges its token at this org with the P0 Agent app.
      tokenExchange: {
        type: "object",
        properties: {
          tokenEndpoint: { type: "string" },
          clientId: { type: "string" },
          audience: { type: "string" },
        },
      },
    },
    render: { locator: "org", policy: "permissionSet" } as const,
  }),
};

export type SalesforceAiAccesses = typeof SalesforceAiAccesses;
